// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38C3z","index":"styles_index__3QR4Y"};